import { baseSiteEndPoint, buildHeaders, getSellerID, urlFilters } from "./common";
import { authorizedFetch } from "./login";
import Bugsnag from "@bugsnag/js";

export const apiCreateEventLogo = async (file) => {
  if (!file) {
    throw new Error("File is required");
  }

  try {
    const formData = new FormData();
    formData.append('file', file);
    const response = await authorizedFetch(`${baseSiteEndPoint}/event/seller/${getSellerID()}/events/upload_logo/`, {
      method: "POST",
      headers: {},
      body: formData,
    });

    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiCreateEvent = async (payload) => {
  try {
    const response = await authorizedFetch(`${baseSiteEndPoint}/event/seller/${getSellerID()}/events/`, {
      method: "POST",
      headers: buildHeaders(),
      body: JSON.stringify(payload)
    });
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiListEvents = async (filters) => {
  try {
    const response = await authorizedFetch(urlFilters(`${baseSiteEndPoint}/event/seller/${getSellerID()}/events`, filters), {
      method: "GET",
      headers: buildHeaders(),
    });
    const data = await response.json();

    return data;
  } catch (error) {
    throw error;
  }
};

export const apiGetEvent = async (id) => {
  try {
    const response = await authorizedFetch(`${baseSiteEndPoint}/event/seller/${getSellerID()}/events/${id}/`, {
      method: "GET",
      headers: buildHeaders(),
    });
    const data = await response.json();

    return data;
  } catch (error) {
    throw error;
  }
};

export const apiEditEvent = async (id, payload) => {
  try {
    const response = await authorizedFetch(`${baseSiteEndPoint}/event/seller/${getSellerID()}/events/${id}/`, {
      method: "PUT",
      headers: buildHeaders(),
      body: JSON.stringify(payload)
    });
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiDeleteEvent = async (id) => {
  try {
    const response = await authorizedFetch(`${baseSiteEndPoint}/event/seller/${getSellerID()}/events/${id}/`, {
      method: "DELETE",
      headers: buildHeaders(),
    });
    if (response.status === 204) {
      return { success: true };
    } else {
      const errorData = await response.json();
      throw new Error(errorData.message || "Erro ao deletar o evento");
    }
  } catch (error) {
    throw error;
  }
};

export const apiCreateEventTicket = async (id, payload) => {
  try {
    const response = await authorizedFetch(`${baseSiteEndPoint}/event/seller/${getSellerID()}/events/${id}/tickets/`, {
      method: "POST",
      headers: buildHeaders(),
      body: JSON.stringify(payload)
    });
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiGetEventTickets = async (id, ticketID) => {
  try {
    const response = await authorizedFetch(`${baseSiteEndPoint}/event/seller/${getSellerID()}/events/${id}/tickets/`, {
      method: "GET",
      headers: buildHeaders(),
    });
    const data = await response.json();

    return data;
  } catch (error) {
    throw error;
  }
};

export const apiGetEventTicketDetail = async (id, ticketID) => {
  try {
    const response = await authorizedFetch(`${baseSiteEndPoint}/event/seller/${getSellerID()}/events/${id}/tickets/${ticketID}`, {
      method: "GET",
      headers: buildHeaders(),
    });
    const data = await response.json();

    return data;
  } catch (error) {
    throw error;
  }
};

export const apiEditEventTicket = async (id, ticketID, payload) => {
  try {
    const response = await authorizedFetch(`${baseSiteEndPoint}/event/seller/${getSellerID()}/events/${id}/tickets/${ticketID}/`, {
      method: "PUT",
      headers: buildHeaders(),
      body: JSON.stringify(payload)
    });
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiDeleteEventTicket = async (id, ticketID) => {
  try {
    const response = await authorizedFetch(`${baseSiteEndPoint}/event/seller/${getSellerID()}/events/${id}/tickets/${ticketID}/`, {
      method: "DELETE",
      headers: buildHeaders(),
    });
    if (response.status === 204) {
      return { success: true };
    } else {
      const errorData = await response.json();
      throw new Error(errorData.error || errorData.message || "Erro ao deletar o ticket");
    }
  } catch (error) {
    throw error;
  }
};

export const apiGetEventNoAuth = async (id) => {
  try {
    const response = await fetch(`${baseSiteEndPoint}/event/event/${id}`, {
      method: "GET",
      headers: buildHeaders(),
    });

    if (!response.ok) {
      throw new Error(`Erro na resposta: ${response.status} ${response.statusText}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiListEventsPay = async (eventID, filters) => {
  try {
    const response = await authorizedFetch(urlFilters(`${baseSiteEndPoint}/event/seller/${getSellerID()}/events/${eventID}/checkouts`, filters), {
      method: "GET",
      headers: buildHeaders(),
    });
    const data = await response.json();

    return data;
  } catch (error) {
    throw error;
  }
};

export const apiGetEventCheckoutDetails = async (eventID, checkoutID) => {
  try {
    const response = await authorizedFetch(`${baseSiteEndPoint}/event/seller/${getSellerID()}/events/${eventID}/checkouts/${checkoutID}/`, {
      method: "GET",
      headers: buildHeaders(),
    });
    const data = await response.json();

    return data;
  } catch (error) {
    throw error;
  }
};

export const apiResendEventCheckoutEmail = async (eventID, checkoutID, email = null) => {
  try {
    const body = email ? { email } : {};
    const response = await authorizedFetch(`${baseSiteEndPoint}/event/seller/${getSellerID()}/events/${eventID}/checkouts/${checkoutID}/resend-email/`, {
      method: "POST",
      headers: buildHeaders(),
      body: JSON.stringify(body)
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || errorData.detail || "Erro ao reenviar e-mail");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    Bugsnag.notify(error);
    throw error;
  }
};

export const apiMarkEventCheckoutAsPaid = async (eventID, checkoutID, sendEmail) => {
  try {
    const response = await authorizedFetch(`${baseSiteEndPoint}/event/seller/${getSellerID()}/events/${eventID}/checkouts/${checkoutID}/mark-as-paid/`, {
      method: "POST",
      headers: buildHeaders(),
      body: JSON.stringify({ send_email: sendEmail })
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || errorData.message || errorData.detail || "Erro ao marcar a compra como paga");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    Bugsnag.notify(error);
    throw error;
  }
};

export const apiPaymentDownload = async (id, format, filters) => {
  try {
    const acceptHeader =
      format === 'csv'
        ? 'text/csv'
        : 'application/vnd.ms-excel';

    const response = await authorizedFetch(
      urlFilters(`${baseSiteEndPoint}/event/seller/${getSellerID()}/events/${id}/checkouts/report/`, filters),
      {
        method: 'GET',
        headers: {
          ...buildHeaders(),
          Accept: acceptHeader,
        },
      }
    );

    return response.blob();
  } catch (error) {
    throw error;
  }
};

// COUPON APIs
export const apiGetEventCoupons = async (eventId) => {
  try {
    const response = await authorizedFetch(`${baseSiteEndPoint}/event/seller/${getSellerID()}/events/${eventId}/coupons/`, {
      method: "GET",
      headers: buildHeaders(),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiCreateEventCoupon = async (eventId, payload) => {
  try {
    const response = await authorizedFetch(`${baseSiteEndPoint}/event/seller/${getSellerID()}/events/${eventId}/coupons/`, {
      method: "POST",
      headers: buildHeaders(),
      body: JSON.stringify(payload)
    });
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiEditEventCoupon = async (eventId, couponId, payload) => {
  try {
    const response = await authorizedFetch(`${baseSiteEndPoint}/event/seller/${getSellerID()}/events/${eventId}/coupons/${couponId}/`, {
      method: "PUT",
      headers: buildHeaders(),
      body: JSON.stringify(payload)
    });
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiDeleteEventCoupon = async (eventId, couponId) => {
  try {
    const response = await authorizedFetch(`${baseSiteEndPoint}/event/seller/${getSellerID()}/events/${eventId}/coupons/${couponId}/`, {
      method: "DELETE",
      headers: buildHeaders(),
    });
    if (response.status === 204) {
      return { success: true };
    } else {
      const errorData = await response.json();
      throw new Error(errorData.message || "Erro ao deletar o cupom");
    }
  } catch (error) {
    throw error;
  }
};

export const apiValidateTicket = async (eventId, ticketCheckoutId) => {
  try {
    const response = await authorizedFetch(`${baseSiteEndPoint}/event/seller/${getSellerID()}/events/${eventId}/checkouts/validate-ticket/`, {
      method: "POST",
      headers: buildHeaders(),
      body: JSON.stringify({ ticketCheckoutId })
    });

    const data = await response.json();
    return { success: true, message: data.message, status: response.status };
  } catch (error) {
    // authorizedFetch rejects on !response.ok, so we handle errors here
    if (error.status && error.message) {
      // Extract error message from the rejected error object
      const errorMessage = error.message.error || error.message.detail || error.message;
      return { success: false, error: errorMessage, status: error.status };
    }
    throw error;
  }
};